import { render, staticRenderFns } from "./OCDetailComponentGlobal.vue?vue&type=template&id=1df07e4e&scoped=true&"
import script from "./OCDetailComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./OCDetailComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./OCDetailComponentGlobal.vue?vue&type=style&index=0&id=1df07e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df07e4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VContainer,VDataTable,VDivider,VIcon,VRow,VSpacer})
